/* Crumb sizing and colour come from the header's breadcrumb slot (header.module.css) */
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
}

.link {
  cursor: pointer;
}

.homeLink {
  flex-shrink: 0;
}

.separator {
  flex-shrink: 0;
}

.nameLink {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
